"use strict";
Object.defineProperty(exports, "__esModule", {
    value: true
});
Object.defineProperty(exports, "valider", {
    enumerable: true,
    get: function() {
        return valider;
    }
});
var _feilmeldingerForKortType = require("./feilmeldingerForKortType");
var _feilmeldingerForRedigerteKortISkattemelding = require("./feilmeldingerForRedigerteKortISkattemelding");
var _triggers = require("./triggers");
var _feilmeldingerForFeltMedAlleValideringsregler = /*#__PURE__*/ _interop_require_default(require("./feilmeldingerForFeltMedAlleValideringsregler"));
function _interop_require_default(obj) {
    return obj && obj.__esModule ? obj : {
        default: obj
    };
}
var valider = {
    feilmeldingerForFeltMedRegelFilter: _feilmeldingerForFeltMedAlleValideringsregler.default,
    feilmeldingerForFeltPerTastetrykk: (0, _feilmeldingerForFeltMedAlleValideringsregler.default)(_triggers.tastetrykk),
    feilmeldingerForFeltPaaFokusTap: (0, _feilmeldingerForFeltMedAlleValideringsregler.default)(_triggers.fokustap),
    feilmeldingerForKortType: (0, _feilmeldingerForKortType.feilmeldingerForKortType)((0, _feilmeldingerForFeltMedAlleValideringsregler.default)()),
    feilmeldingerForRedigerteKortISkattemelding: (0, _feilmeldingerForRedigerteKortISkattemelding.feilmeldingerForRedigerteKortISkattemelding)((0, _feilmeldingerForFeltMedAlleValideringsregler.default)())
};
